import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Button } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import api from "../../services/api";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import SL_Date from "../../components/dates/Date";
import moment from "moment";
import { SL_AutoCompleteSelect } from "../../components/selects/SL_AutoCompleteSelect";
import SL_Button from "../../components/buttons/Button";
import { displayMessage } from "../../services/helper";

export default function ControlFilters({ loadPatientsByDentistData, loadActivePatientsHourData, start_date, end_date }) {
    const { mobile_mode, setShowLoading, user } = useContext(GeneralContext);


    const [dentistsList, setDentistsList] = useState([]);
    const [patientsList, setPatientsList] = useState([]);
    const [selectedPatients, setSelectedPatients] = useState([]);
    const [isFiltersVisible, setIsFiltersVisible] = useState(true);
    const [currentFilters, setCurrentFilters] = useState({
        start_date: moment(start_date).format('yyyy-MM-DD'),
        end_date: moment(end_date).format('yyyy-MM-DD')
    });

    useEffect(() => {
        loadDentistsList();
        loadPatientsList();
    }, [])

    const loadDentistsList = async () => {
        try {
            setShowLoading(true);

            const response = await api.dentist.list({});

            setDentistsList(response.data);

            setShowLoading(false);

        } catch (error) {
            console.log(error);
            setDentistsList([]);
            setShowLoading(false);
        }
    }

    const loadPatientsList = async () => {
        setShowLoading(true);

        const response = await api.patient.list({limit_to_x_registers: 50})

        setPatientsList(response.data);

        setShowLoading(false);
    }

    let populateDentistsTimeout;

    async function populateDentistsSelect(value) {
        return new Promise((resolve) => {
            clearTimeout(populateDentistsTimeout);
            populateDentistsTimeout = setTimeout(async () => {
                const options = [];
                const filterValue = value.toUpperCase();

        const { data } = await api.dentist.list({find: value, limit_to_x_registers: 50});

                data.map((dentist) => {
                    const dentistFullName = dentist.full_name.toUpperCase();
                    if (dentistFullName.includes(filterValue)) {
                        const alreadyUsed = options.find(e => e.value == dentist.full_name);
                        if (!alreadyUsed) {
                            let option = {
                                key: dentist.id,
                                label: dentist.full_name,
                                value: dentist.full_name
                            }
                            options.push(option);
                        }
                    }
                })

                resolve(options)
            }, 1000)
        })
    }

    let populatePatientsTimeout;

    async function populatePatientsSelect(value) {
        return new Promise((resolve) => {
            clearTimeout(populatePatientsTimeout);
            populatePatientsTimeout = setTimeout(async () => {
                const options = [];
                const filterValue = value.toUpperCase();

                const { data } = await api.patient.list({find: value, limit_to_x_registers: 50, dentist_id: currentFilters.dentist_id});

                data.map((patient) => {
                    const patientFullName = patient.full_name.toUpperCase();
                    if (patientFullName.includes(filterValue)) {
                        const alreadyUsed = options.find(e => e.value == patient.full_name);
                        if (!alreadyUsed) {
                            let option = {
                                key: patient.id,
                                label: patient.full_name,
                                value: patient.full_name
                            };
                            options.push(option);
                        }
                    }
                });

                setSelectedPatients(options);
                resolve(options);
            }, 1000);
        });
    }

    async function filterData() {
        try {
            setShowLoading(true);
            await loadPatientsByDentistData(currentFilters);
            await loadActivePatientsHourData(currentFilters);
            setShowLoading(false);
        } catch (error) {
            console.log(error);
            setShowLoading(false);
        }
    }

    return (
        <div style={
            {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                padding: 0,
                marginBottom: 15,
                color: 'white',
                overflow: 'hidden',
                border: '1px solid lightgrey'
            }}>

            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
                <SL_Button
                    style={{ background: 'white', borderColor: 'darkblue', color: 'black', fontWeight: 'bold' }}
                    className='items-center w-30 flex'
                    onClick={() => { isFiltersVisible ? setIsFiltersVisible(false) : setIsFiltersVisible(true) }}
                    shape="circle"
                    icon={isFiltersVisible ? <UpOutlined /> : <DownOutlined />}
                />
            </div>
            {
                isFiltersVisible &&
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>

                    <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: 'wrap', flex: 1, rowGap: mobile_mode ? 5 : 0 }}>

                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}>{displayMessage('INITIAL_DATE')}</div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: mobile_mode ? 160 : 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={start_date => setCurrentFilters({ ...currentFilters, start_date: start_date?.format('YYYY-MM-DD') })}
                                    defaultValue={moment(start_date)}
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}>{displayMessage('FINAL_DATE')}</div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: mobile_mode ? 160 : 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={end_date => setCurrentFilters({ ...currentFilters, end_date: end_date?.format('YYYY-MM-DD') })}
                                    defaultValue={moment(end_date)}
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> {displayMessage('DENTIST')}:</div>
                                <SL_AutoCompleteSelect
                                    onChange={
                                        newValue => setCurrentFilters({ ...currentFilters, dentist_id: newValue.map(e => e.key) })
                                    }
                                    placeholder={displayMessage('DENTIST')}
                                    fetchOptions={e => populateDentistsSelect(e)}

                                />

                            </div>

                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> {displayMessage('PATIENT')}:</div>
                                <SL_AutoCompleteSelect
                                    onChange={
                                        newValue => setCurrentFilters({ ...currentFilters, patients_ids: newValue.map(e => e.key) })
                                    }
                                    placeholder={displayMessage('PATIENT')}
                                    fetchOptions={e => populatePatientsSelect(e)}
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                            <Button
                                style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                                type="primary"
                                onClick={() => filterData()}
                            >
                                {displayMessage('SEARCH')}
                            </Button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}